import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useUrl } from "../../../../../hooks/usePage";
import { Pagetype } from "../../../../../interfaces/Config";
import { HierarchyPath } from "../../../../../components/TreeCheckboxGroup";
import { useCallback } from "react";
import { ROUTES } from "../../../../../design-system-components/WorkmodeLayout/const";
const useResourceURL = () => {
    const queryParams = new URLSearchParams(useLocation().search);
    const queryString = queryParams.toString();

    const history = useHistory();
    const playlistModeUrl = useUrl(Pagetype.WORKMODE_PLAYLIST);
    const editMatch = useRouteMatch(
        `${playlistModeUrl}/${ROUTES.edit}/:playlistId`
    );

    const goToResourceURL = useCallback(
        (resourcePath: HierarchyPath) => {
            editMatch
                ? history.push(
                      `${editMatch.url}/` +
                          resourcePath +
                          (queryString ? "?" + queryString : "")
                  )
                : history.push(
                      `${playlistModeUrl}/${ROUTES.create}/` +
                          resourcePath +
                          (queryString ? "?" + queryString : "")
                  );
        },
        [history, playlistModeUrl, editMatch, queryString]
    );

    return {
        goToResourceURL,
    };
};
export default useResourceURL;
